<template>

    <button v-if="type !== 'dots'" class="dropdown-toggle" :class="classes" type="button">
        <span v-if="prefix" class="prefix">{{ prefix }}:</span>
        <span>{{ label | truncate(30) }}</span>
        <i class="fas fa-chevron-down ml-5"></i>
    </button>

    <v-button-dots v-else />

</template>

<style scoped lang="scss">

    .dropdown-toggle {
        @include font-semibold(11px);
        align-items: center;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        max-width: 400px;
        overflow: hidden;
        position: relative;
        text-decoration: none;
        text-overflow: ellipsis;
        transition: all .3s;
        user-select: none;
        white-space: nowrap;
        &::after {
            display: none;
        }
        .prefix {
            color: $color-primary;
            margin-right: 5px;
        }
    }

    .dropdown-toggle {
        &.btn-xs {
            border-radius: 3px;
            font-size: 10px;
            height: 30px;
            padding: 0 10px;
        }
        &.btn-sm {
            border-radius: 3px;
            font-size: 11px;
            height: 40px;
            padding: 0 15px;
        }
    }

    .dropdown-toggle {
        &.btn-white, .btn-white:focus {
            background: #fff;
            border: 1px solid $color-rule;
            color: $color-text;
            &:hover, &:active, &.active {
                background: #fff;
                border-color: $color-text;
                color: $color-text;
            }
        }
        &.btn-secondary, .btn-secondary:focus {
            background: $color-secondary;
            color: $color-text;
            &:hover, &:active, &.active {
                background: $color-secondary-hover;
                color: $color-text;
            }
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'sm',
        },
        type: {
            type: String,
            default: 'white',
        },
        label: {
            type: String,
            default: 'Select Option',
        },
        prefix: {
            type: String,
        },
    },

    computed: {

        classes() {
            return {
                // Sizes
                'btn-xs': this.size === 'xs',
                'btn-sm': this.size === 'sm',
                // Types
                'btn-secondary': this.type === 'secondary',
                'btn-white': this.type === 'white',
            };
        },

    },

}

</script>
